// extracted by mini-css-extract-plugin
module.exports = {"icon":"icon_icon__3Se8Z","inline":"icon_inline__1igLg"};